export default "__VITE_ASSET__d7a6d69b__"